import { IconCard, IconGrid, IconLine, IconPie, IconBar } from 'eva-component/ui/icon';
import React, { useEffect, useState } from 'react'
import { Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row } from 'reactstrap';

function DashboardAnalyzerSetting( { newDashboardName, selectedTemplate, selectedTemplateItem, onSave }) {
    const [checkedItems, setCheckedItems] = useState({});

    useEffect(() => {
        // Initialize all items as checked
        const initialCheckedState = {};
        selectedTemplateItem.forEach(item => {
            initialCheckedState[item.name] = true;
        });
        setCheckedItems(initialCheckedState);
    }, [selectedTemplate, selectedTemplateItem])

    const handleToggleItem = (itemName) => {
        setCheckedItems(prevState => ({
            ...prevState,
            [itemName]: !prevState[itemName]
        }));
    };

    const handleSave = () => {
        // Filter selectedTemplateItem to get only checked items
        const checkedTemplateItems = selectedTemplateItem.filter(item => 
            checkedItems[item.name]
        );
        
        // Call the onSave prop with the filtered items
        if (onSave) {
            onSave(checkedTemplateItems);
        }
    };

    const getIcon = (visual_type) => {
        if(visual_type === 'Grid')
            return <IconGrid />

        if(visual_type === 'Pie Chart')
            return <IconPie />

        if(visual_type === 'Bar Chart')
            return <IconBar />

        if(visual_type === 'Line Chart')
            return <IconLine />

        if(visual_type === 'Card')
            return <IconCard />

        return <IconGrid />
    }
    return (
        (selectedTemplate || selectedTemplateItem.length > 0) ?
        <div style={{ padding: '10px 10px', border: '1px solid #e0e0e0', borderTop: 'none', marginBottom: 10, position: 'relative' }}>
            <Row>
                <Col xl='12'>
                    <FormGroup>
                        <Label 
                            htmlFor="newDashboardName" 
                            style={{ 
                                fontWeight: 'bold', 
                                fontSize: 14, 
                                marginBottom: 7
                            }}
                        >Dashboard Name</Label>
                        <Input
                            key={1}
                            type="text"
                            id="newDashboardName"
                            placeholder="Dashboard Name"
                            value={newDashboardName}
                            disabled={true}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xl='12'>       
                    <FormGroup>
                    <Label 
                            style={{ 
                                fontWeight: 'bold', 
                                fontSize: 14, 
                                marginBottom: 7
                            }}
                        >List of dashboard items for analysis</Label>
                    {selectedTemplateItem.length > 0 && selectedTemplateItem.map((item, index) => (
                        <div
                            className='templateItem'
                            key={`detail-${index}`}
                        >
                            <Label check>
                                <Input
                                    type="checkbox"
                                    bsSize="xl"
                                    checked={checkedItems[item.name] || false}
                                    onChange={() => handleToggleItem(item.name)}
                                />
                                {getIcon(item.visual_type)} {item.name} 
                            </Label>
                        </div>
                    ))}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xl='12' className="text-right">
                    <Button 
                        color="primary" 
                        size="sm"
                        outline
                        onClick={handleSave}
                        disabled={selectedTemplateItem.length === 0}
                    >
                        Save Setting
                    </Button>
                </Col>
            </Row>
        </div>
        :
        <div className="dashboardItems" style={{
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', // Center horizontally
            justifyContent: 'center', // Center vertically
            flexWrap: 'wrap'
        }}>
            <div className="dashboardItemError" style={{color: '#9f9f9f'}}>No Dashboard Selected</div>
            <div className="dashboardItemError" style={{color: '#9f9f9f', fontSize: '13px', fontWeight: 400}}>Please select a dashboard from the list</div>
        </div>
    )
}

export default DashboardAnalyzerSetting